if (!customElements.get('quantity-calculator')) {
  class QuantityCalculator extends HTMLElement {
    constructor() {
      super();

      this.prices = this.querySelector('[data-price]').getAttribute('data-price');
      this.unitInput = this.querySelector('input[name="unit"]');
      this.invalidMessage = this.querySelector('[data-invalid-message]');
      this.priceElement = this.querySelector('[data-price]');
      this.quantityInput = this.querySelector('input[name="quantity"]');
      this.crossSellWrapper = document.querySelector('.product-page__cross-sell-wrapper');
      if (!this.quantityInput || !this.priceElement) return;

      const plantingDistance = this.quantityInput.dataset.plantingDistance;
      this.plantingDistance = Number(plantingDistance) || 1;

      this.quantityInput.addEventListener('input', () => this.onQuantityChanged());
      this.unitInput?.addEventListener('input', () => this.onUnitChanged());

      this.handleCrossSelling(this.quantityInput.valueAsNumber);

      this.calculatePrice(this.prices, this.quantityInput.valueAsNumber);

      this.updateFormQuantity();
    }

    updateFormQuantity() {
      const newQuantity = this.quantityInput.valueAsNumber || 1;

      this.formQuantity = document.querySelector('product-form input[name="quantity"]');
      this.formQuantity.value = newQuantity;
    }

    onQuantityChanged() {
      const value = this.quantityInput.valueAsNumber;

      if (this.unitInput) this.unitInput.value = (value * this.plantingDistance).toFixed(2);

      this.updateFormQuantity();
      this.handleValidationMessage();
      this.calculatePrice(this.prices, this.quantityInput.valueAsNumber);
      this.handleCrossSelling(this.quantityInput.valueAsNumber);
    }

    onUnitChanged() {
      const value = this.unitInput.valueAsNumber;

      if (this.quantityInput) this.quantityInput.value = Math.ceil(value / this.plantingDistance);

      this.updateFormQuantity();
      this.handleValidationMessage();
      this.calculatePrice(this.prices, this.quantityInput.valueAsNumber);
      this.handleCrossSelling(this.quantityInput.valueAsNumber);
    }

    handleValidationMessage() {
      const value = this.quantityInput.valueAsNumber;
      this.invalidMessage.innerHTML = this.invalidMessage.textContent.replace('{0}', value);

      let display = this.quantityInput.checkValidity() ? 'none' : 'block';
      this.invalidMessage.style.display = display;
    }

    // Update with tiered pricing
    calculatePrice(prices, quantity, flag) {
      if (!prices || quantity === undefined) return;

      let bulkPrices;

      if (prices?.includes(';')) {
        // Parse the prices string into an array of objects
        bulkPrices = prices.split(';').map((item) => {
          let [q, price] = item.split(':');

          // Replace comma with dot for parsing
          price = price.replace(',', '.');

          return { quantity: parseInt(q), pricePerUnit: parseFloat(price) };
        });
      } else if (prices?.includes(':')) {
        // Parse the prices string into an object
        const [q, price] = prices.split(':');

        // Replace comma with dot for parsing
        const pricePerUnit = price.replace(',', '.');

        bulkPrices = [{ quantity: parseInt(q), pricePerUnit: parseFloat(pricePerUnit) }];
      } else {
        // Single price format
        const pricePerUnit = parseFloat(prices) / 100; // Assuming the price is in cents
        bulkPrices = [{ quantity: 1, pricePerUnit }];
      }

      // Sort the price tiers by quantity in descending order
      bulkPrices.sort((a, b) => b.quantity - a.quantity);

      // Find the applicable price tier
      const applicableTier = bulkPrices.find((tier) => quantity >= tier.quantity);

      if (!applicableTier) {
        return;
      }

      // Calculate the total price
      let totalPrice = quantity * applicableTier.pricePerUnit;

      // Replace dot with comma for output
      totalPrice = totalPrice.toFixed(2).replace('.', ',');

      if (flag) {
        return totalPrice;
      }

      // Update the price element
      this.priceElement.textContent = totalPrice;
    }

    getBulkprices() {
      return this.prices;
    }

    // Handle cross-selling based on quantity
    handleCrossSelling(quantity, prices) {
      if (this.crossSellWrapper) {
        const self = this;
        const crossSellQuantities = this.crossSellWrapper.querySelectorAll('.cross-sell-qty');
        const crossSellPrices = this.crossSellWrapper.querySelectorAll('.cross-sell-price');

        // Update cross-sell quantities
        crossSellQuantities.forEach((crossSell, index) => {
          const qty = Math.ceil(quantity * crossSell.dataset.crossSellRatio);

          crossSell.textContent = qty;
          crossSell.closest('cross-sell').dataset.quantity = qty;

          this.minQuantity = parseInt(crossSell.closest('cross-sell').dataset.minQuantity);
          qty < this.minQuantity
            ? crossSell.closest('cross-sell').classList.add('less-than-min')
            : crossSell.closest('cross-sell').classList.remove('less-than-min');

          // Update cross-sell items in the window object
          window.crossSellItems = window.crossSellItems.map((item) => {
            if (item.id === parseInt(crossSell.closest('cross-sell').dataset.id)) {
              return { id: item.id, quantity: qty };
            }

            return item;
          });
        });

        // Update cross-sell prices
        crossSellPrices.forEach((crossSell) => {
          const price = self.calculatePrice(
            crossSell.dataset.price,
            crossSell.closest('cross-sell').dataset.quantity,
            true
          );
          price
            ? ((crossSell.textContent = price),
              crossSell.closest('cross-sell').classList.remove('hidden'))
            : crossSell.closest('cross-sell').classList.add('hidden');
        });
      }
    }
  }

  customElements.define('quantity-calculator', QuantityCalculator);
}
